module.exports = __webpack_public_path__ + "static/media/ourProcess@2x.b82368fc.jpg";